'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaPauseOutline = function TiMediaPauseOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 33.3c-2.7 0-5-2.2-5-5v-15c0-2.7 2.3-5 5-5s5 2.3 5 5v15c0 2.8-2.2 5-5 5z m0-21.6c-0.9 0-1.6 0.7-1.6 1.6v15c0 1 0.7 1.7 1.6 1.7s1.7-0.7 1.7-1.7v-15c0-0.9-0.7-1.6-1.7-1.6z m11.7 21.6c-2.8 0-5-2.2-5-5v-15c0-2.7 2.2-5 5-5s5 2.3 5 5v15c0 2.8-2.2 5-5 5z m0-21.6c-0.9 0-1.7 0.7-1.7 1.6v15c0 1 0.8 1.7 1.7 1.7s1.7-0.7 1.7-1.7v-15c0-0.9-0.8-1.6-1.7-1.6z' })
        )
    );
};

exports.default = TiMediaPauseOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-pause-outline.js
// module id = 3135
// module chunks = 0